import { css } from 'styled-components';
export var hiddenInput = function hiddenInput() {
  return css(["opacity:0;position:absolute;z-index:-1;"]);
};
export var clearfix = function clearfix() {
  return css(["&:before,&:after{content:' ';display:table;}&:after{clear:both;}"]);
};
export var srOnly = function srOnly() {
  return css(["border:0;clip:rect(0,0,0,0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;"]);
};
export var textOverflow = function textOverflow() {
  return css(["overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
};